import CheckIcon from '@mui/icons-material/Check';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FITS_BUDGET_TITLE, TOOLBAR_CONTROL_SX } from '../../../constants/marketplace';
import { HOVER_MEDIA } from '../../../constants/ui';
import { marketplaceSetFiltersAction } from '../../../store/actions/marketplace';
import { selectMarketplaceFilters } from '../../../store/selectors/marketplace';

export const FitsBudgetToggle: React.FC = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectMarketplaceFilters);

  const handleToggle = useCallback(() => {
    dispatch(marketplaceSetFiltersAction({ fitsBudget: !filters.fitsBudget }));
  }, [dispatch, filters.fitsBudget]);

  const toggleSx: SxProps<Theme> = useMemo(
    () => ({
      ...TOOLBAR_CONTROL_SX,
      ...(filters.fitsBudget && {
        color: 'primary.main',
        borderColor: ({ palette }) => alpha(palette.primary.main, 0.5),
        backgroundColor: ({ palette }) => alpha(palette.primary.main, palette.action.selectedOpacity),
        [HOVER_MEDIA]: {
          '&:hover': {
            backgroundColor: ({ palette }) => alpha(palette.primary.main, palette.action.focusOpacity),
            borderColor: ({ palette }) => alpha(palette.primary.main, 0.5),
          },
        },
      }),
    }),
    [filters.fitsBudget],
  );

  const toggleIcon = filters.fitsBudget ? (
    <CheckIcon sx={{ fontSize: 18 }} />
  ) : (
    <FilterAltOutlinedIcon sx={{ fontSize: 18, color: 'action.active' }} />
  );

  return (
    <Button
      onClick={handleToggle}
      aria-pressed={filters.fitsBudget}
      title={FITS_BUDGET_TITLE}
      startIcon={toggleIcon}
      data-action="fits_budget_toggle"
      sx={toggleSx}
    >
      Fits budget
    </Button>
  );
};
